import { AppState } from 'redux/reducers';

export const getRightMenuWidth = ({ headerNavigation }: AppState) => headerNavigation.rightMenuWidth;
export const getHeaderAsianSearchWidth = ({ headerNavigation }: AppState) => headerNavigation.asianSearchWidth;
export const getHeaderMoreBtnWidth = ({ headerNavigation }: AppState) => headerNavigation.moreBtnWidth;
export const getLeftMenuItemsWidth = ({ headerNavigation }: AppState) => headerNavigation.leftMenuItemsWidth;
